<template>
  <div class="vehicle-animation">
    <div class="exhaust-container">
      <div class="exhaust-puff puff-1"></div>
      <div class="exhaust-puff puff-2"></div>
      <div class="exhaust-puff puff-3"></div>
    </div>
    <div class="vehicle-icon">
      <svg viewBox="0 0 100 28" width="75" height="21">
        <!-- main body -->
        <rect x="4" y="10" width="90" height="12" rx="2" fill="#0a0a0a"/>
        <!-- roof curve -->
        <path d="M 16 10 Q 18 5, 26 5 L 74 5 Q 82 5, 84 10" fill="#0a0a0a"/>
        <!-- chrome trim line -->
        <rect x="4" y="18" width="90" height="1" fill="#888"/>
        <!-- rear window (tinted) -->
        <path d="M 16 10 Q 17 6, 24 6 L 24 10 Z" fill="#222"/>
        <!-- passenger windows (tinted, evenly spaced) -->
        <rect x="28" y="6" width="8" height="5" rx="1" fill="#222"/>
        <rect x="38" y="6" width="8" height="5" rx="1" fill="#222"/>
        <rect x="48" y="6" width="8" height="5" rx="1" fill="#222"/>
        <rect x="58" y="6" width="8" height="5" rx="1" fill="#222"/>
        <rect x="68" y="6" width="8" height="5" rx="1" fill="#222"/>
        <!-- front windshield -->
        <path d="M 78 6 Q 82 5, 84 10 L 84 12 L 78 12 Z" fill="#333"/>
        <!-- hood -->
        <rect x="84" y="10" width="10" height="8" rx="1" fill="#0a0a0a"/>
        <!-- wheels with chrome hubcaps -->
        <circle cx="20" cy="22" r="5" fill="#111"/>
        <circle cx="20" cy="22" r="3.5" fill="#333"/>
        <circle cx="20" cy="22" r="2" fill="#999"/>
        <circle cx="80" cy="22" r="5" fill="#111"/>
        <circle cx="80" cy="22" r="3.5" fill="#333"/>
        <circle cx="80" cy="22" r="2" fill="#999"/>
        <!-- headlights -->
        <rect x="92" y="12" width="2" height="2" rx="1" fill="#ffdd00"/>
        <rect x="92" y="15" width="2" height="2" rx="1" fill="#ffdd00"/>
        <!-- taillights -->
        <rect x="4" y="12" width="2" height="4" rx="1" fill="#cc0000"/>
        <!-- door handles (chrome) -->
        <rect x="34" y="14" width="2" height="1" fill="#888"/>
        <rect x="54" y="14" width="2" height="1" fill="#888"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LimoAnimation'
}
</script>

<style scoped>
.vehicle-animation {
  display: flex;
  align-items: center;
}

.exhaust-container {
  position: relative;
  width: 0px;
  height: 24px;
  margin-left: 20px;
}

.exhaust-puff {
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #999;
  border-radius: 50%;
  opacity: 0;
  right: 0;
}

.puff-1 {
  bottom: 4px;
  animation: puff-float 1.2s ease-out infinite;
}

.puff-2 {
  bottom: 8px;
  animation: puff-float 1.2s ease-out infinite 0.4s;
}

.puff-3 {
  bottom: 12px;
  animation: puff-float 1.2s ease-out infinite 0.8s;
}

.vehicle-icon {
  animation: vehicle-bounce 0.5s ease-in-out infinite;
}

@keyframes vehicle-bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-2px); }
}

@keyframes puff-float {
  0% {
    opacity: 0.7;
    transform: translateX(0) scale(0.5);
  }
  100% {
    opacity: 0;
    transform: translateX(-15px) scale(1.2);
  }
}
</style>
